export type ResearchType = "Op-ed" | "Article" | "Essay" | "Analysis";

export interface ResearchItem {
  id: string;
  title: string;
  venue: string;
  type: ResearchType;
  url: string;
  published: string; // Month YYYY
  summary: string;
  registryNote?: string;
  external: boolean;
}

export const medicaleseResearch: ResearchItem = {
  id: "i-dont-speak-medicalese",
  title: "I Don't Speak Medicalese",
  venue: "davidisei.com",
  type: "Article",
  url: "/articles/i-dont-speak-medicalese",
  published: "",
  summary: "I run a coalition of clinicians, and I am not one.",
  external: false,
};

export const research: ResearchItem[] = [
  {
    id: "geography-not-billing-code",
    title: "Geography Is Not a Billing Code",
    venue: "davidisei.com",
    type: "Article",
    url: "/articles/geography-not-billing-code",
    published: "May 2026",
    summary:
      "Neighbor-island patients pay more for the same care than Oʻahu residents with identical insurance. It is pricing design, not geography.",
    external: false,
  },
  {
    id: "644-doctors-short",
    title: "You Are 644 Doctors Short. The Number Is Getting Worse.",
    venue: "davidisei.com",
    type: "Article",
    url: "/articles/644-doctors-short",
    published: "May 2026",
    summary:
      "Hawaiʻi has 12,688 licensed physicians but only 3,044 practicing FTE, a 644-physician shortfall driven by retention, not recruitment.",
    external: false,
  },
  {
    id: "directory-is-lying",
    title: "The Directory Is Lying to You",
    venue: "davidisei.com",
    type: "Article",
    url: "/articles/directory-is-lying",
    published: "May 2026",
    summary:
      "What ghost networks actually cost Hawaiʻi patients and why no one is held accountable.",
    registryNote:
      "The 412-listing reachability sample is retired; the current directory figure is the +107 percent overstatement measured against a verified truth set. See the Corrections Log.",
    external: false,
  },
  {
    id: "776-physician-gap",
    title: "The 776-Physician Gap",
    venue: "davidisei.com",
    type: "Article",
    url: "/articles/776-physician-gap",
    published: "April 2026",
    summary:
      "Why Hawaiʻi's doctor shortage is a federal math problem, and what a state-of-the-union fix actually requires.",
    registryNote:
      "The 776 FTE shortage figure is superseded by 644 FTE direct and 832.6 FTE island-adjusted (JABSOM AHEC 2025). See the Corrections Log.",
    external: false,
  },
  {
    id: "hidden-tax-hawaii-medicine",
    title: "The Hidden Tax on Hawaiʻi Medicine",
    venue: "davidisei.com",
    type: "Article",
    url: "/articles/hidden-tax-hawaii-medicine",
    published: "April 2026",
    summary:
      "How the general excise tax on medical services quietly drains primary care capacity statewide, and the structural reform on the table.",
    external: false,
  },
  {
    id: "network-adequacy-theater",
    title: "Network Adequacy Theater",
    venue: "davidisei.com",
    type: "Article",
    url: "/articles/network-adequacy-theater",
    published: "April 2026",
    summary:
      "Hawaiʻi's network adequacy rules are paperwork, not access. What the data actually shows.",
    external: false,
  },
  {
    id: "neighbor-island-surcharge",
    title: "The Neighbor-Island Surcharge",
    venue: "davidisei.com",
    type: "Article",
    url: "/articles/neighbor-island-surcharge",
    published: "March 2026",
    summary:
      "Geography is not a billing code. The hidden cost of treating Hawaiʻi like a single county.",
    external: false,
  },
  {
    id: "2-3-billion-question",
    title: "The $2.3 Billion Question",
    venue: "davidisei.com",
    type: "Article",
    url: "/articles/2-3-billion-question",
    published: "March 2026",
    summary:
      "Where the money already goes, and why the system keeps starving the front line.",
    registryNote:
      "The $2.3 billion figure is a triangulated range of $2 to $3 billion, not a fixed value. See the Corrections Log.",
    external: false,
  },
  {
    id: "merger-math",
    title: "Merger Math",
    venue: "davidisei.com",
    type: "Article",
    url: "/articles/merger-math",
    published: "March 2026",
    summary:
      "The arithmetic behind the latest health-system consolidation and what it means for patients across the islands.",
    registryNote:
      "The measured statewide commercial HHI is 3,138 (NAIC 2024). See the Corrections Log.",
    external: false,
  },
  {
    id: "tf-mammography",
    title:
      "Hawaiʻi Island Has Enough Mammography Machines. What It Does Not Have Is a Way to Reach Them.",
    venue: "Hawaiʻi Healthcare Task Force",
    type: "Op-ed",
    url:
      "https://hawaiihealthcaretaskforce.org/blog/hawai-i-island-has-enough-mammography-machines-what-it-does-not-have-is-a-way-to-msoiqwor",
    published: "August 2026",
    summary:
      "The first Hawaiʻi measurement of how distance to a certified facility affects screening: 0.068 percentage points lost per mile across 26 Hawaiʻi Island ZIP areas, ecological and labeled so.",
    external: true,
  },
  {
    id: "tf-invisible-twice",
    title: "Invisible Twice: The Behavioral Health Network Hawaiʻi Never Measured",
    venue: "Hawaiʻi Healthcare Task Force",
    type: "Article",
    url: "https://hawaiihealthcaretaskforce.org/blog/invisible-twice",
    published: "August 2026",
    summary:
      "147 adult civil acute psychiatric beds, 10.2 per 100,000, and the state's own external quality review excluding members with serious mental illness from network validation.",
    external: true,
  },
  {
    id: "tf-pbm",
    title:
      "The Price You Don't See: How Pharmacy Benefit Managers Shape Hawaiʻi's Healthcare Costs",
    venue: "Hawaiʻi Healthcare Task Force",
    type: "Article",
    url:
      "https://hawaiihealthcaretaskforce.org/blog/the-price-you-don-t-see-how-pharmacy-benefit-managers-shape-hawai-i-s-healthcare-mpk78ng3",
    published: "May 2026",
    summary:
      "How pharmacy benefit managers set what patients and plans pay.",
    external: true,
  },
];
